<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0">
            <v-card elevation="1" class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Documenti</p>
                </v-card-title>                    
                <v-divider></v-divider>
                <v-container class="pa-0 pt-4" fluid>
                    <v-row class="ma-0">
                        <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                            <v-text-field
                                type="number"
                                label="Numero Sconti"
                                v-model="settings['discounts_number']"
                                v-validate="'min_value:0|max_value:5'"
                                :error-messages="errors.collect('Numero Sconti')"
                                :data-vv-name="'Numero Sconti'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <!-- <v-col class="pt-0 pb-0 px-4" cols="12" sm="12" md="6" >
                            <v-text-field
                                type="number"
                                label="Decimali Prezzi"
                                v-model="settings['decimals_number']"
                                v-validate="'min_value:0|max_value:5'"
                                :error-messages="errors.collect('Decimali Prezzi')"
                                :data-vv-name="'Decimali Prezzi'"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col> -->
                        
                    </v-row>

                    <v-row class="ma-0">
                        <v-col class="pt-0 pb-0 px-4" cols="6" sm="6" md="6" >
                            <v-text-field
                                type="text"
                                label="Codice Prodotto da utilizzare come Bollo"
                                v-model="settings['stamp_product']"
                                v-validate="'max:255'"
                                :error-messages="errors.collect('Codice Prodotto')"
                                data-vv-name="Codice Prodotto"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="6" sm="6" md="6">
                            <v-autocomplete
                                label="Categoria IVA per Bollo"
                                v-model="settings['stamp_vat']"
                                :error-messages="errors.collect('Categoria IVA per Bollo')"
                                :data-vv-name="'Categoria IVA per Bollo'"
                                :items="vats"
                                outlined
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="6" sm="6" md="6">
                            <v-text-field
                                type="text"
                                label="Codice Prodotto da utilizzare come Spese di Incasso"
                                v-model="settings['collection_fee_code']"
                                v-validate="'max:255'"
                                :error-messages="errors.collect('Codice Prodotto Spese di Incasso')"
                                data-vv-name="Codice Prodotto Spese di Incasso"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12">
                            <v-switch
                                label="Escludi sconti da prodotti di tipo Spesa"
                                v-model="settings['exclude_discount_from_expense']"
                                color="primary"
                                inset
                            ></v-switch>
                        </v-col>
                        <v-col class="pt-0 pb-0 px-4" cols="12">
                            <v-checkbox
                                label="Multivaluta"
                                v-model="settings['multicurrency']"
                                color="primary"
                            ></v-checkbox>
                        </v-col>
                        
                    </v-row>
                </v-container>
                <v-divider></v-divider>
                <v-card-actions class="pr-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
                        
            </v-card>
        </v-col>
		<v-col class="pa-0 pt-4" cols="12">
			<crud
				title="Tipo di costo"
				action-icon='settings'
				model-def='generaltypes-recurrence_type'
				action-position='absolute'
				crudDialog
			></crud>
		</v-col>

		<!-- Porti / Trasporto a mezzo: vivono nelle impostazioni DDT (DdtsOther).
			 Qui li esponiamo SOLO ai tenant senza modulo DDT, così chi non ha i DDT
			 può comunque configurarli — senza duplicarli per chi ha già i DDT. -->
		<template v-if="!$store.getters.checkModulePermissions('ddts')">
			<v-col class="pa-0 pt-4" cols="12">
				<crud
					title="Porti"
					action-icon='settings'
					model-def='generaltypes-ddt_port'
					action-position='absolute'
					crudDialog
				></crud>
			</v-col>

			<v-col class="pa-0 pt-4" cols="12">
				<crud
					title="Trasporto a mezzo"
					action-icon='settings'
					model-def='generaltypes-ddt_transport_by'
					action-position='absolute'
					crudDialog
				></crud>
			</v-col>
		</template>
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    export default {
        name: 'documents-settings',
        mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'document',
                vats: [],
                settings: {
                    'discounts_number': '',
                    'stamp_vat': null
                },
            }
        },

        created() {
            this.axios.post('generaltype', {key: 'vat'}).then(response => {
                this.vats = response.data.general_type
            }, response => {
                // error
            })
        }
    }
</script>